import React, { memo, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import pathnames from "routes/pathnames";

import formatIndexNumber from "common/format-index-number";

import { yesNoOptions } from "constants/yes-no-options";
import { statusOptions } from "constants/status-options";

import OfficeLocationTableProps from "dto/components/pages/office-location/page-office-location-table-dto";
import { PageOfficeLocationTableDto } from "dto/pages/office-location/page-office-location-list";

import AppPagination from "components/app-pagination";

import editIcon from "assets/images/components/app-articles-table/edit-icon.svg";

const OfficeLocationTable: React.FC<OfficeLocationTableProps> = ({ locations, currentPage, totalPages, fetching, onPageChange }) => {
	const navigate = useNavigate();
	const isEmptyData = useMemo(() => locations.length === 0 && !fetching, [locations.length, fetching]);

	//prettier-ignore
	const onHandleEdit = useCallback((id: string) => {
        navigate(pathnames.officeLocationInfo + id);
    }, [navigate]);

	const getLabel = (options: { label: string; value: string }[], value: string) => {
		return options.find((option) => option.value === value)?.label || value;
	};

	const formatAddress = (fullAddress: PageOfficeLocationTableDto["fullAddress"]) => {
		const parts = [fullAddress.address1, fullAddress.address2, fullAddress.address3, fullAddress.postcode, fullAddress.region, fullAddress.state, fullAddress.country].filter(Boolean);
		return parts.join(" ");
	};

	return (
		<div className="app-office-location-table">
			<div className="location-table">
				<div className="location-table__wrapper">
					<table className="location-table__container">
						<thead className="location-table__header">
							<tr>
								<th className="location-table__th">No.</th>

								<th className="location-table__th">Location</th>

								<th className="location-table__th">Full Address</th>

								<th className="location-table__th">Contact Email</th>

								<th className="location-table__th">Headquarter</th>

								<th className="location-table__th">Status</th>
							</tr>
						</thead>

						<tbody className="location-table__content">
							{!isEmptyData &&
								locations.map((location, index) => (
									<tr className="location-table__tr" key={location.id}>
										<td className="location-table__td">{formatIndexNumber(index + 1 + 10 * currentPage)}</td>

										<td className="location-table__td">{location.location}</td>

										<td className="location-table__td">{formatAddress(location.fullAddress)}</td>

										<td className="location-table__td">{location.contactEmail}</td>

										<td className="location-table__td">{getLabel(yesNoOptions, location.headquarter.toString())}</td>

										<td className={location.status === "active" ? "location-table__td--active" : "location-table__td--inactive"}>{getLabel(statusOptions, location.status)}</td>

										<td className="location-table__td">
											<button className="location-table__edit-button" onClick={() => onHandleEdit(location.id)}>
												<img src={editIcon} alt="Edit" />
											</button>
										</td>
									</tr>
								))}

							{fetching && (
								<tr className="location-table__tr">
									<td className="location-table__message" colSpan={7}>
										Loading...
									</td>
								</tr>
							)}

							{isEmptyData && (
								<tr className="location-table__tr">
									<td className="location-table__message" colSpan={7}>
										No records found
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				{!isEmptyData && !fetching && <AppPagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />}
			</div>
		</div>
	);
};

export default memo(OfficeLocationTable);
